export default __webpack_public_path__ + "fonts/cp_logo.5a0fcd9e3f74c3ad3f79d15ec1a527d2.png";